import axios from 'axios';

import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  TextField,
} from '@mui/material';
// components
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
// sections
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';
// mock
import USERLIST from '../_mock/user';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import { Navigate, useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";

import InfoIcon from '@mui/icons-material/Info';
import CancelIcon from '@mui/icons-material/Cancel';

import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';

// ----------------------------------------------------------------------


// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function TripsPage() {
  const navigate = useNavigate();

  const mashawiritoken = localStorage.getItem('mashawiritoken');

  useEffect(() => {
    setIsloading(true);
    const fetchData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}get_schedule_trips`, {
          headers: {
            Authorization: `Bearer ${mashawiritoken}`,
          },
        });
        console.log('response');
        console.log(response.data.data);
        setResponseData(response.data.data);
        setFilteredData(response.data.data);
        setIsloading(false);
      } catch (error) {
        console.error(error);
        setIsloading(true);
      }
    };

    fetchData();
  }, []);
  const { t } = useTranslation();

  const TABLE_HEAD = [
    // { id: 'image', label: 'Image', alignRight: false },
    { id: 'driver', label: t('driver'), alignRight: false },
    { id: 'phone', label: t('Phone'), alignRight: false },
    { id: 'car tyep', label: t('CarType'), alignRight: false },
    { id: 'source', label: t('Source'), alignRight: false },
    { id: 'destination', label: t('Distination'), alignRight: false },
    { id: 'cash', label: t('Cash'), alignRight: false },
    { id: 'status', label: t('Status'), alignRight: false },
    { id: 'type', label: t('Type'), alignRight: false },
    // { id: 'region', label: 'Region', alignRight: false },
  
    { id: '' },
  ];
  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('name');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [ResponseData, setResponseData] = useState([]);

  const [openPopUp, setOpenPopUp] = useState(false);

  const [selectedElement, setSelectedElement] = useState({});

  const [selectedId, SetSelectedId] = useState(null);

  const [selectedTyep, SetSelectedTyep] = useState(null);

  const [filteredData, setFilteredData] = useState([]);

  const [isloading, setIsloading] = useState(true);

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = ResponseData.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClickOpen = () => {
    setOpenPopUp(true);
  };

  const handleClose = () => {
    setOpenPopUp(false);
  };

  const handleAdd = async (state) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}add_client_to_company`,
        {
          phone: state.phone,
        },
        {
          headers: {
            Authorization: `Bearer ${mashawiritoken}`,
          },
        }
      );

      if (response.status === 200 && response.data.status === true) {
        const newUser = {
          id: response.data.data.id,
          first_name: response.data.data.name,
          phone: response.data.data.phone,
        };

        setResponseData([...ResponseData, newUser]);
        console.log('ResponseData');
        console.log(ResponseData);
        console.log('ResponseData2');
        console.log(response.data);
        handleClose();
      } else {
        alert(response.data.message);
        handleClose();
      }
    } catch (error) {
      console.error(error);
      alert('Sorry something went wrong please try again later');
      handleClose();
    }
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - ResponseData.length) : 0;

  const filteredUsers = applySortFilter(ResponseData, getComparator(order, orderBy), filterName);

  const isNotFound = !filteredUsers.length && !!filterName;

  const handleDelete = async (id) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}delete_client_from_company`,
        {
          id: id,
        },
        {
          headers: {
            Authorization: `Bearer ${mashawiritoken}`,
          },
        }
      );
      if (response.status === 200 && response.data.status === true) {
        console.log(response.data.status);
        setResponseData((prev) => {
          return prev.filter((user) => user.id !== id);
        });
      }
    } catch (error) {
      console.error(error);
      alert('Sorry something went wrong please try again later');
    }
  };

  const handleDetails = (id, type) => {
    navigate('/dashboard/details', { state: { id, type } });
  };

  const filterTripsByStatus = (status) => {
    if (status === 'all') {
      setFilteredData(ResponseData); // استعادة جميع البيانات الأصلية
    } else {
      const filteredTrips = ResponseData.filter((trip) => trip.status === status);
      setFilteredData(filteredTrips);
    }
  };

  const handleCancel = async (id, tyep) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}cancel_company_trip?trip_id=${id}&text=تم الغاء الرحلة من قبل ادمن الشركة&type=${tyep}`,
        {
          headers: {
            Authorization: `Bearer ${mashawiritoken}`,
          },
        }
      );
      console.log(id);
      console.log(response);
       if (response.status === 200 && response.data.status === true) {
      //   // console.log(response.data.status);
      //   // setResponseData((prev) => {
      //   //   return prev.filter((user) => user.id !== id);
      //   // });
        window.location.reload();
        handleClose();
       } else {
        handleClose();
        alert(response.data.message);
       }
    } catch (error) {
      console.error(error);
      // alert('عذرا حدث خطأ الرجاء المحاولة لاحقا');
      // handleClose();
    }
  };

  return (
    <>
      <Helmet>
        <title>{t('Trips')}</title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h3" gutterBottom>
            {t('Mashawiri')}
          </Typography>
          {/* <Button onClick={handleClickOpen} variant="contained" startIcon={<Iconify icon="eva:plus-fill" />}>
            New Trip
          </Button> */}
        </Stack>

        <Card>
          <UserListToolbar
            name={t("My Schedule Trips")}
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={handleFilterByName}
            filterTripsByStatus={filterTripsByStatus}
            data={filteredData}
          />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              {isloading && (
                <Box sx={{ width: '100%' }}>
                  <LinearProgress />
                </Box>
              )}
              {!isloading && (
                <Table>
                  <UserListHead
                    order={order}
                    orderBy={orderBy}
                    headLabel={TABLE_HEAD}
                    // rowCount={ResponseData.length}
                    // numSelected={selected.length}
                    // onRequestSort={handleRequestSort}
                    // onSelectAllClick={handleSelectAllClick}
                  />
                  <TableBody>
                    {filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                      const { id, driver_id, driver_phone, cartype_id, source, destination, cash, status, type } = row;
                      // const selectedUser = selected.indexOf(id) !== -1;

                      return (
                        <TableRow hover key={id} tabIndex={-1} role="checkbox">
                          <TableCell padding="checkbox">
                            {/* <Checkbox checked={selectedUser} onChange={(event) => handleClick(event, driver_id)} /> */}
                          </TableCell>

                          <TableCell component="th" scope="row" padding="none">
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Avatar alt={driver_id} src={driver_id} />
                              <Typography variant="subtitle2" noWrap>
                                {driver_id}
                              </Typography>
                            </Stack>
                          </TableCell>

                          <TableCell align="left">{driver_phone}</TableCell>
                          <TableCell align="left">{cartype_id}</TableCell>
                          <TableCell align="left">{source}</TableCell>
                          <TableCell align="left">{destination}</TableCell>
                          <TableCell align="left">{cash}</TableCell>
                          <TableCell align="left">{status}</TableCell>
                          <TableCell align="left">{type}</TableCell>
                          <TableCell align="right">
                            <IconButton
                              size="large"
                              color="inherit"
                              onClick={(event) => {
                                setOpen(event.currentTarget);
                                // setSelectedElement({
                                //   id: id,
                                // });
                                SetSelectedId(id);
                                SetSelectedTyep(type);
                              }}
                            >
                              <Iconify icon={'eva:more-vertical-fill'} />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                    {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>

                  {isNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                          <Paper
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            <Typography variant="h6" paragraph>
                              {t('Not found')}
                            </Typography>

                            <Typography variant="body2">
                              {t('No results found for')} &nbsp;
                              <strong>&quot;{filterName}&quot;</strong>.
                              <br /> {t('Try checking for typos or using complete words.')}
                            </Typography>
                          </Paper>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              )}
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={ResponseData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem sx={{ color: 'error.main' }}>
          <Button
            onClick={() => {
              handleDetails(selectedId, selectedTyep);
            }}
            sx={{ color: '#000', width: '100%', height: '100%' }}
          >
            <InfoIcon sx={{ mr: 2 }} />
            {t('Details')}
          </Button>
        </MenuItem>

        <MenuItem sx={{ color: 'error.main' }}>
          <Button
            onClick={() => {
              handleCancel(selectedId, selectedTyep);
            }}
            sx={{ color: '#000', width: '100%', height: '100%' }}
          >
            <CancelIcon sx={{ mr: 2 }} />
            {t('Cancel')}
          </Button>
        </MenuItem>
      </Popover>
      <Dialog
        open={openPopUp}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`Add user information`}</DialogTitle>
        <DialogContent>
          <TextField
            label={t("Phone")}
            value={selectedElement.phone}
            onChange={(event) => setSelectedElement({ ...selectedElement, phone: event.target.value })}
            fullWidth
            margin="normal"
          />
          {/* <TextField
            label="Region"
            value={selectedElement.region}
            onChange={(event) => setSelectedElement({ ...selectedElement, region: event.target.value })}
            fullWidth
            margin="normal"
          /> */}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{t('Cancel')}</Button>
          <Button
            onClick={() => {
              handleAdd(selectedElement);
            }}
            autoFocus
          >
            {t('Add')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
